import {Component} from 'react';
import {default as _} from "../../../helpers/Translate";
import {connect} from "react-redux";
import Storage from "../../../helpers/Storage";

class T extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: Storage.getLanguage(),
            token: this.props.token || "",
        };
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.language !== this.props.language) {
            this.setState({
                lang: this.props.language
            });
        }

        if (prevProps.token !== this.props.token) {
            this.setState({
                token: this.props.token
            });
        }
    }

    render() {
        return _.syncNumberWithLanguage(_.init(this.state.token, this.state.lang), this.state.lang);
    }
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(T);